import { CompleteConsentForm, CompleteConsentFormResponse } from '@/api/dtos';
import { OnlinePatientManagementContext } from '@ngt/opms';
import { useCallback, useContext } from 'react';

export interface UseCompleteConsentFormOptions {
    revalidateForm?: () => Promise<unknown>;
    refreshSummary?: () => Promise<unknown>;
}

const useCompleteConsentForm = ({
    revalidateForm,
    refreshSummary
}: UseCompleteConsentFormOptions = {}) => {
    const { serviceStackClient } = useContext(OnlinePatientManagementContext);

    return useCallback(async (request: CompleteConsentForm) => {
        const response = await serviceStackClient.post<CompleteConsentFormResponse>(request);

        await Promise.all([
            revalidateForm?.(),
            refreshSummary?.()
        ]);

        return response;
    }, [serviceStackClient, revalidateForm, refreshSummary]);
};

export default useCompleteConsentForm;
